import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const bgColor = (theme: Theme, color: string) =>
  // @ts-ignore
  theme.palette.colors[color];
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      position: 'relative',
    },
    title: {
      width: '100%',
      fontSize: 28,
      color: '#333333',
      fontWeight: 'bold',
      textAlign: 'start',
      paddingLeft: 32,
      paddingTop: 32,
    },
    gridContainer: {
      paddingTop: 5,
      paddingBottom: 5,
    },
    resetPtop: {
      paddingTop: 0,
    },
    dropzone: {
      outline: 'none',
    },
    dropzoneCursor: {
      cursor: 'pointer',
    },
    dragActive: {
      borderColor: '#E1E8ED',
    },
    haveFile: {
      border: '1px dashed #E1E8ED',
      borderRadius: 12,
      paddingBottom: theme.spacing(1),
      margin: '16px 0',
    },
    uploadMessage: {
      fontWeight: 300,
      textAlign: 'center',
      '& p': {
        fontSize: '0.8rem',
      },
      padding: '0 12px 12px',
    },
    uploadIcon: {
      fontSize: theme.spacing(8),
    },
    textContainer: {
      marginTop: -theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    helpText: {
      fontWeight: 300,
      fontSize: '0.98em',
      margin: 0,
      marginBottom: 2,
      textAlign: 'start',
    },
    nextButton: {
      minWidth: 135,
      background: '#0094FF',
      borderRadius: 10,
      textTransform: 'none',
      color: theme.palette.colors.white,
      marginTop: theme.spacing(2),
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    nextButtonDisabled: {
      minWidth: 135,
      background: '#E1E8ED',
      borderRadius: 10,
      textTransform: 'none',
      color: theme.palette.colors.white,
      marginTop: theme.spacing(2),
      '&:hover': {
        background: '#E1E8ED',
        filter: 'brightness(0.9)',
      },
    },
    maintainButton: {
      background: theme.palette.colors.gray6,
      color: theme.palette.colors.gray1,
    },
    chooseFileText: {
      color: '#0094FF',
      fontSize: '0.8rem',
      textDecoration: 'underline',
    },
    closeIconContainer: {
      position: 'absolute',
      right: '-20px',
      top: '-20px',
    },
    container: {
      height: '50%',
      width: '50%',
      border: '1px dashed #E1E8ED',
      borderRadius: 12,
      display: 'grid',
    },
  }),
);

export default useStyles;
